<!--
 * @Author: zjt
 * @Email: 13928932429@163.com
 * @Date: 2020-08-10 10:36:12
 * @LastEditTime: 2020-10-28 15:59:12
 * @Description: 销售订单页面
-->
<template>
  <div class="container">
    <Modal
      width="1000"
      v-model="createPlanDateModal"
      title="计划时间"
      @on-ok="createPlanDate"
      @on-cancel="cancelPlanDate"
    >
      <div class="create-planDate-wrap">
        <!-- 计划生产 producedAtPlan -->
        <!-- <div class="create-planDate create-planDate-mid">
          <div>计划生产</div>
          <div class="select-time">
            <DatePicker
              type="date"
              format="M-d"
              placeholder="请选择日期"
              style="width: 220px"
              v-model="producedAtPlanDate"
            ></DatePicker>
            <TimePicker
              format="H:mm"
              style="width: 112px"
              v-model="producedAtPlanTime"
              placeholder="选择时间"
            ></TimePicker>
          </div>
          <div class="option-cell-list" style="width: 100%; margin-top: 20px">
            <div
              v-for="(d, index) in dateOption"
              :key="index"
              @click="dateClick(d.addDates, 'producedAtPlanDate')"
              :class="{
                    'option-cell': true,
                    selected: d.addDates === producedAtPlanDateValue,
                  }"
            >{{ d.name }}</div>
          </div>
          <div class="option-cell-list">
            <div
              v-for="(t, index) in timeOption"
              :key="index"
              :class="{
                    'option-cell': true,
                    selected: t.time === producedAtPlanTime,
                  }"
              @click="timeClick(t, 'producedAtPlanTime')"
            >{{ t.time }}</div>
          </div>
        </div> -->
        <!-- 计划出发 departAtPlan -->
        <div class="create-planDate create-planDate-left">
          <div>计划出发</div>
          <div class="select-time">
            <DatePicker
              type="date"
              format="M-d"
              placeholder="请选择日期"
              style="width: 220px"
              v-model="departAtPlanDate"
            ></DatePicker>
            <TimePicker
              format="H:mm"
              style="width: 112px"
              v-model="departAtPlanTime"
              placeholder="选择时间"
            ></TimePicker>
          </div>
          <div class="option-cell-list" style="width: 100%; margin-top: 20px">
            <div
              v-for="(d, index) in dateOption"
              :key="index"
              @click="dateClick(d.addDates, 'departAtPlanDate')"
              :class="{
                    'option-cell': true,
                    selected: d.addDates === departAtPlanDateValue,
                  }"
            >{{ d.name }}</div>
          </div>
          <div class="option-cell-list">
            <div
              v-for="(t, index) in timeOption"
              :key="index"
              :class="{
                    'option-cell': true,
                    selected: t.time === departAtPlanTime,
                  }"
              @click="timeClick(t, 'departAtPlanTime')"
            >{{ t.time }}</div>
          </div>
        </div>
        <!-- 需求时间 -->
        <div class="required-time">
          <div>需求时间</div>
          <h2>{{modalNeedData}}</h2>
        </div>
      </div>
    </Modal>
    <Modal
      v-model="cancelSalesOrderModal"
      title="取消销售订单"
      @on-ok="cancelOperate()"
      @on-cancel="cancelSalesOrderModal = false"
    >
      <div>取消{{cancaleSalesOrder?cancaleSalesOrder.sales.abbr:""}}{{cancaleSalesOrder?cancaleSalesOrder.volPlan:""}}吨订单</div>
      <Form @submit.native.prevent :model="formItem" ref="formItem" :label-width="80">
        <FormItem label="取消理由">
          <Input type="text" v-model="formItem.canceledReason" placeholder="请输入取消销售订单的理由" />
        </FormItem>
      </Form>
    </Modal>
    <div class="upper-panel">
      <div style="display: flex; align-items: center">
        <h2>订单日期：</h2>
        <Icon
          type="md-arrow-dropleft"
          size="24"
          style="cursor: pointer"
          @click="changeplanArrivedAt(null, null, '-')"
        />
        <DatePicker
          type="date"
          :open="dateCalOpen"
          :options="planArrivedAtOptions"
          @on-change="changeplanArrivedAt"
          @on-clickoutside="dateCalOpen = false"
        >
          <h1
            @click="dateCalOpen = !dateCalOpen"
            style="cursor: pointer"
          >{{ planArrivedAtDisplay }}</h1>
        </DatePicker>
        <Icon
          type="md-arrow-dropright"
          size="24"
          style="cursor: pointer"
          @click="changeplanArrivedAt(null, null, '+')"
        />
      </div>
    </div>
    <div class="lower-panel">
      <div
        v-for="f in factorySalesOrderList"
        :key="f.factory._id"
        class="table-content"
        @mousedown="saveFactorySalesOrder(f)"
      >
        <div class="section-header-wrapper">
          <h3>
            {{ f.factory.name }}
            <span
              style="margin-left: 20px"
            >合计{{ calcSalesOrderVolPlan(f.salesOrder) }}吨</span>
          </h3>
          <div class="header-operate">
            <span>共{{ f.salesOrder.length }}条</span>
            <!-- <Page
              :total="f.totalCounts"
              :page-size="15"
              @on-change="changePage($event, f._id)"
              show-total
              simple
              style="margin-right: 24px"
            />-->
            <Button type="primary" @click="openAddNewSODrawer(f)">新增订单</Button>
          </div>
        </div>
        <Table
          ref="SOTable"
          :loading="tableLoading"
          :columns="columns"
          :data="f.salesOrder"
          :row-class-name="rowClassName"
          :draggable="false"
          border
          @on-drag-drop="dragLine"
        >
          <template
            slot-scope="{ row }"
            slot="action"
            v-if="
              user.superAdmin ||
              arrayIntersection(
                [
                  'sales',
                  'factoryLeader',
                  'deliveryLeader',
                  'deliveryAssist',
                ],
                user.simpleRole
              ).length > 0
            "
          >
            <Button
                type="primary"
                size="small"
                ghost
                style="margin-right: 5px;"
                v-if="!row.startedAt"
                @click="$refs.SalesOrderReturnDrawer.openDrawer(row)"
              >退货</Button>
              <Button
                type="error"
                size="small"
                v-if="!row.startedAt"
                ghost
                @click="cancel(row, f._id)"
              >取消</Button>
          </template>
        </Table>
      </div>
    </div>
    <AddSalesOrderDrawer ref="AddSalesOrderDrawer" />
    <EditDeliveryDrawer ref="EditDeliveryDrawer" />
    <SalesOrderReturnDrawer ref="SalesOrderReturnDrawer" />
    <SODrawer ref="SODrawer" />
  </div>
</template>

<script>
import AddSalesOrderDrawer from "./AddSalesOrderDrawer";
import EditDeliveryDrawer from "./EditDeliveryDrawer";
import SalesOrderReturnDrawer from "./SalesOrderReturnDrawer";
import { mapState, mapActions, mapGetters, mapMutations } from "vuex";
import dayjs from "dayjs";
import SODrawer from "./SODrawer";
import { arrayIntersection } from "@/utils";

const returnTypeToText = {
  full: "打不下",
  quality: "质量问题",
  others: "其它"
};
export default {
  components: {
    AddSalesOrderDrawer,
    EditDeliveryDrawer,
    SODrawer,
    SalesOrderReturnDrawer
  },
  data() {
    return {
      producedAtPlanValue: null,
      selectSalesOrder: null,
      createPlanDateModal: false,
      formItem: {
        canceledReason: null
      },
      factoryId: null,
      cancaleSalesOrderId: null,
      cancaleSalesOrder: null,
      cancelSalesOrderModal: false,
      tableLoading: true,
      planArrivedAtOptions: {
        shortcuts: [
          {
            text: "今天",
            value() {
              return new Date();
            }
          },
          {
            text: "全部",
            value() {
              return null;
            }
          }
        ]
      },
      planArrivedAt: null,
      page: 0,
      searchText: "",
      dateCalOpen: false,
      tableLoading: false,
      columns: [
        {
          title: "销售项目",
          key: "sales",
          width: 150,
          render: (h, params) =>
            h(
              "span",
              {
                style: {
                  color: "#42b983",
                  cursor: "pointer"
                },
                on: {
                  click: () => {
                    const mode = params.row.startedAt ? null : "edit";
                    this.$refs.SODrawer.openDrawer(params.row);
                  }
                }
              },
              params.row.sales?.abbr
            )
        },
        {
          title: "产品型号",
          width: 90,
          key: "model",
          render: (h, params) => h("span", params.row.material?.model)
        },
        {
          title: "配方",
          width: 120,
          key: "recipe",
          render: (h, params) =>
            h(
              "span",
              "#" +
                params.row.recipe?.NoId +
                "(" +
                params.row.recipe?.name +
                ")"
            )
        },
        {
          title: "吨数",
          key: "volPlan",
          width: 60,
          align: "right",
        },
        {
          title: "需求时间",
          key: "orderedBy",
          width: 100,
          align: "right",
          render: (h, params) =>
            h("span", dayjs(params.row.planArrivedAt).format("H:mm"))
        },
        {
          title: "车辆",
          key: "vehicle",
          width: 90,
          render: (h, params) => {
            if (params.row.delivery && params.row.delivery.vehicle)
              return h(
                "span",
                {
                  props: {
                    type: "primary",
                    size: "small"
                  },
                  style: {
                    cursor: "pointer"
                  },
                  on: {
                    click: async () => {
                      this.createDeliveryInRow(params.row, "vehicle");
                    }
                  }
                },
                params.row.delivery.vehicle.plate
              );
            if (
              this.user.superAdmin ||
              arrayIntersection(
                ["deliveryAssist", "deliveryLeader", "factoryLeader"],
                this.user.simpleRole
              ).length > 0
            )
              return h(
                "span",
                {
                  props: {
                    type: "primary",
                    size: "small"
                  },
                  style: {
                    color: "#42b983",
                    cursor: "pointer"
                  },
                  on: {
                    click: async () =>
                      this.createDeliveryInRow(params.row, "vehicle")
                  }
                },
                "创建运输"
              );
          }
        },
        {
          title: "司机",
          key: "driver",
          width: 90,
          render: (h, params) => {
            if (
              params.row.delivery &&
              params.row.delivery.vehicle &&
              params.row.delivery.driver
            ) {
              const str = params.row.delivery.driver
                .map(x => x.name)
                .join(", ");
              return h(
                "div",
                {
                  props: {
                    type: "primary",
                    size: "small"
                  },
                  style: {
                    cursor: "pointer"
                  },
                  on: {
                    click: async () =>
                      this.createDeliveryInRow(params.row, "driver")
                  }
                },
                str
              );
            }
          }
        },
        
        {
          title: "备注",
          width: 160,
          key: "remark"
        },
        {
          title: "实际抵达时间",
          width: 140,
          key: "orderedBy",
          render: (h, params) => {
            if (params.row.arrivedAt) {
              return h(
                "span",
                dayjs(params.row.arrivedAt).format("MM-DD HH:mm")
              );
            }
          }
        },
        {
          title: "退货类型",
          width: 110,
          key: "orderedBy",
          render: (h, params) => {
            return h(
              "span",
              params.row.returnType
                ? returnTypeToText[params.row.returnType]
                : ""
            );
          }
        },
        {
          title: "退货数量",
          width: 110,
          key: "orderedBy",
          align: "right",
          render: (h, params) => {
            return h("span", params.row.volReturn ? params.row.volReturn : "");
          }
        },
        {
          title: "退货原因",
          width: 140,
          key: "orderedBy",
          render: (h, params) => {
            return h(
              "span",
              params.row.returnReason ? params.row.returnReason : ""
            );
          }
        },
        {
          title: "创建人",
          key: "createdBy",
          width: 90,
          // fixed: "right",
          // className: 'tableSlotRight',
          render: (h, params) => h("span", params.row.createdBy.name)
        },
        {
          title: "操作",
          key: "操作",
          slot: "action",
          align: "center",
          fixed: "right",
          width: 140,
          // className: 'btn-col',
        }
      ],
      selectFactory: null,
      timeOption: [
        { ampm: "am", time: "5:00" },
        { ampm: "am", time: "6:00" },
        { ampm: "am", time: "7:00" },
        { ampm: "am", time: "8:00" },
        { ampm: "am", time: "9:00" },
        { ampm: "am", time: "10:00" },
        { ampm: "am", time: "11:00" },
        { ampm: "pm", time: "12:00" },
        { ampm: "pm", time: "13:00" },
        { ampm: "pm", time: "14:00" },
        { ampm: "pm", time: "15:00" },
        { ampm: "pm", time: "16:00" },
        { ampm: "pm", time: "17:00" },
        { ampm: "pm", time: "18:00" },
        { ampm: "pm", time: "19:00" },
        { ampm: "pm", time: "20:00" },
        { ampm: "pm", time: "21:00" },
        { ampm: "pm", time: "22:00" },
        { ampm: "pm", time: "23:00" },
        { ampm: "pm", time: "0:00" }
      ],
      dateOption: [
        { name: "今天", addDates: 0 },
        { name: "明天", addDates: 1 },
        { name: "后天", addDates: 2 }
      ],
      departAtPlanDate: null,
      departAtPlanTime: null,
      producedAtPlanDate: null,
      producedAtPlanTime: null,
      modalNeedData: null
    };
  },
  computed: {
    ...mapState({
      factorySalesOrderList: state => state.salesOrder.factorySalesOrderList,
      user: state => state.auth.currentUser
    }),
    planArrivedAtDisplay() {
      // if (this.planArrivedAt !== null) {
      //   this.SETPLANARRIVEDAT(this.planArrivedAt);
      //   return dayjs(this.planArrivedAt).format("M月D日").toString();
      // } else {
      //   this.SETPLANARRIVEDAT(null);
      //   return "全部";
      // }
      return dayjs(this.planArrivedAt)
        .format("M-D")
        .toString();
    },
    query() {
      return {
        date: this.planArrivedAt,
        limit: 15
      };
    },
    // 将日期与dateOption对应上
    departAtPlanDateValue: function() {
      if (this.departAtPlanDate === null) return;
      return dayjs(this.departAtPlanDate).get("date") - dayjs().get("date");
    },
    producedAtPlanDateValue: function() {
      if (this.producedAtPlanDate === null) return;
      return dayjs(this.producedAtPlanDate).get("date") - dayjs().get("date");
    }
  },
  methods: {
    arrayIntersection(array, targetArray) {
      return arrayIntersection(array, targetArray);
    },
    ...mapMutations({
      SETPLANARRIVEDAT: "salesOrder/SETPLANARRIVEDAT"
    }),
    openCreatePlanDateModal(row) {
      this.selectSalesOrder = row;
      this.createPlanDateModal = true;
      if (row.producedAtPlan) {
        this.producedAtPlanDate = dayjs(row.producedAtPlan).format("M-D");
        this.producedAtPlanTime = dayjs(row.producedAtPlan).format("H:mm");
      } else {
        this.producedAtPlanDate = dayjs().format("M-D");
        this.producedAtPlanTime = null;
      }
      if (row.delivery && row.delivery.departAtPlan) {
        this.departAtPlanDate = dayjs(row.delivery.departAtPlan).format("M-D");
        this.departAtPlanTime = dayjs(row.delivery.departAtPlan).format("H:mm");
      } else {
        this.departAtPlanDate = dayjs().format("M-D");
        this.departAtPlanTime = null;
      }
      this.modalNeedData = dayjs(row.planArrivedAt).format("M-D H:mm");
    },
    // 更新创建计划出发和计划生产时间
    createPlanDate() {
      try {
        // 更新计划出发时间
        if (this.departAtPlanDate && this.departAtPlanTime) {
          this.updateDelivery({
            id: this.selectSalesOrder.delivery._id,
            data: {
              departAtPlan:
                dayjs(this.departAtPlanDate).format("YYYY-M-D") +
                " " +
                this.departAtPlanTime
            }
          });
        }
        // 更新计划生产时间
        if (this.producedAtPlanDate && this.producedAtPlanTime) {
          this.updateSalesOrder({
            id: this.selectSalesOrder._id,
            data: {
              producedAtPlan:
                dayjs(this.producedAtPlanDate).format("YYYY-M-D") +
                " " +
                this.producedAtPlanTime
            }
          });
        }
      } catch (error) {
        return this.$Message.error(error);
      }
      this.$Message.success("操作成功");
    },
    cancelPlanDate() {},
    dateClick(addDates, type) {
      this[type] = dayjs()
        .set({ hour: 0, minute: 0, second: 0, millisecond: 0 })
        .add(addDates, "d")
        .toDate();
    },
    timeClick(value, type) {
      this[type] = value.time;
    },

    ...mapActions({
      getManyFactorySalesOrder: "salesOrder/getManyFactorySalesOrderAction",
      createSalesOrder: "salesOrder/createSalesOrderAction",
      updateSalesOrder: "salesOrder/updateSalesOrderAction",
      updateDelivery: "delivery/updateDeliveryAction",
      cancelSalesOrder: "salesOrder/cancelSalesOrderAction",
      createDelivery: "delivery/createDeliveryAction",
      createDeliveryBySalesOrder: "delivery/createDeliveryBySalesOrderAction",
      getDelivery: "delivery/getDeliveryAction",
      getSalesOrderByFactoryId: "salesOrder/getSalesOrderByFactoryIdAction",
      getCompanyList: "company/getCompanyListAction",
    }),
    changePage(page, id) {
      this.getSalesOrderByFactoryId({
        id,
        data: { skip: (page - 1) * 15, limit: 15 }
      });
    },
    async createDeliveryInRow(row, status) {
      try {
        const delivery = await this.createDeliveryBySalesOrder(row._id);
        this.$refs.EditDeliveryDrawer.openDrawer(delivery, row, status);
      } catch (error) {
        this.$Message.error(`失败: ${error}`);
      }
    },
    cancel(row, factoryId) {
      this.cancelSalesOrderModal = true;
      this.formItem.canceledReason = null;
      this.cancaleSalesOrderId = row._id;
      this.cancaleSalesOrder = row;
      this.factoryId = factoryId;
      this.formItem.factory = row.factory._id;
    },
    // 判断日期返回日期格式
    dateJudge(date) {
      const currentDate = dayjs(date)
        .format("M-D H:mm")
        .split(" ");
      if (currentDate[0] === this.planArrivedAtDisplay) {
        return currentDate[1];
      } else {
        return dayjs(date).format("M-D H:mm");
      }
    },
    async cancelOperate() {
      await this.cancelSalesOrder({
        id: this.cancaleSalesOrderId,
        data: this.formItem
      });
      this.$Message.success("取消成功!");
    },
    rowClassName(row, index) {
      if (row.canceledAt) return "canceled";
      return "";
    },
    changeplanArrivedAt(dateString, dateType, op) {
      if (op) {
        if (op === "+") {
          const base = this.planArrivedAt
            ? this.planArrivedAt
            : dayjs().toDate();
          this.planArrivedAt = dayjs(base)
            .add(1, "day")
            .format("YYYY-M-D");
        } else if (op === "-") {
          const base2 = this.planArrivedAt
            ? this.planArrivedAt
            : dayjs().toDate();
          this.planArrivedAt = dayjs(base2)
            .subtract(1, "day")
            .format("YYYY-M-D");
        }
      } else {
        if (!dateString) {
          this.planArrivedAt = null;
        } else {
          this.planArrivedAt = dayjs(dateString).toDate();
        }
      }

      this.dateCalOpen = false;
      this.loadSacSalesOrder(this.query);
    },
    async loadSacSalesOrder(conditions) {
      this.tableLoading = true;
      await this.getManyFactorySalesOrder(conditions);
      this.tableLoading = false;
    },
    saveFactorySalesOrder(order) {
      this.selectFactory = order;
    },
    // 表格拖动
    async dragLine(index1, index2) {
      // 判断是不是原地不动
      if (index1 != index2) {
        if (index2 === 0) {
          // this.tableData[index1].indexInDay = this.tableData[0].indexInDay / 2;
          await this.updateSalesOrder({
            id: this.selectFactory.salesOrder[index1]._id,
            data: {
              indexInDay: this.selectFactory.salesOrder[0].indexInDay / 2
            }
          });
        } else if (index2 === this.selectFactory.salesOrder.length - 1) {
          // this.tableData[index1].indexInDay =
          //   this.tableData[index2].indexInDay + 1000;
          await this.updateSalesOrder({
            id: this.selectFactory.salesOrder[index1]._id,
            data: {
              indexInDay:
                this.selectFactory.salesOrder[index2].indexInDay + 1000
            }
          });
        } else {
          if (index1 < index2) {
            // this.tableData[index1].indexInDay =
            //   (this.tableData[index2 + 1].indexInDay +
            //     this.tableData[index2].indexInDay) /
            //   2;
            await this.updateSalesOrder({
              id: this.selectFactory.salesOrder[index1]._id,
              data: {
                indexInDay:
                  (this.selectFactory.salesOrder[index2 + 1].indexInDay +
                    this.selectFactory.salesOrder[index2].indexInDay) /
                  2
              }
            });
          } else {
            // this.tableData[index1].indexInDay =
            //   (this.tableData[index2 - 1].indexInDay +
            //     this.tableData[index2].indexInDay) /
            //   2;
            await this.updateSalesOrder({
              id: this.selectFactory.salesOrder[index1]._id,
              data: {
                indexInDay:
                  (this.selectFactory.salesOrder[index2 - 1].indexInDay +
                    this.selectFactory.salesOrder[index2].indexInDay) /
                  2
              }
            });
          }
        }
      }
    },
    calcSalesOrderVolPlan(salesOrder) {
      let totalVol;
      if (salesOrder.length > 0) {
        totalVol = salesOrder.reduce((totalVol, item) => {
          return totalVol + item.volPlan;
        }, 0);
      } else {
        totalVol = 0;
      }
      return totalVol;
    },
    openAddNewSODrawer(factory) {
      this.$refs.AddSalesOrderDrawer.openDrawer(factory);
    },
    searchSacCompany() {
      this.page = 0;
      this.loadSacSalesOrder();
    },
  },
  created() {
    this.planArrivedAt = dayjs().format("YYYY-M-D");
    this.loadSacSalesOrder(this.query);
    this.getCompanyList({skip: 0, limit: 999});
  },
  mounted() {
    
  }
};
</script>

<style scoped lang="stylus">
.container
  overflow-y auto

.upper-panel
  margin: 8px 16px;
  padding: 2px 8px;
  border-radius: 4px;
  border: 1px solid #8e9e38;
  background-color: #faffdf;

.lower-panel
  // width calc(100% - 200px)
  overflow-y auto
  padding 0 16px
  // margin-left 15px

  .table-content
    margin-bottom 4px
    border 1px solid lightgray
    background-color #ececec

.section-header-wrapper
  padding 0 12px
  height 45px
  display flex
  align-items center
  justify-content space-between

  .ivu-btn, .ivu-btn-primary
    margin-left 12px

.select-wrap
  margin-right 30px
  display flex
  align-items flex-end

.header-operate
  display flex
  align-items center

.series
  font-size 14px
  padding 0 12px
  font-weight bold

.table
  margin-bottom 15px

.option-cell-list
  display flex
  flex-wrap wrap
  align-content flex-start
  overflow-y auto
  margin-top 16px

.option-cell
  font-size 12px
  font-weight 500
  padding 0 8px
  width 50px
  margin 0px 8px 8px 0
  border 1px solid #E2E5ED
  border-radius 4px
  cursor pointer

  &:hover
    color #0168FA
    border 1px solid #0168FA
    box-shadow 0 2px 4px rgba(209, 230, 250, 1)
    transition 0.2s

.selected
  color #0168FA
  border 1px solid #0168FA
  box-shadow 0 2px 4px rgba(209, 230, 250, 1)
  transition 0.2s

.create-planDate-wrap
  display flex
  justify-content space-between

.create-planDate
  width 350px

.required-time
  width 300px
</style>
